import { ISupervisionType } from '../../../APIPackage/DictionariesModule/interfaces/ISupervisionType';
import { IDictionarySelectOption } from '../../../CorePackage/DictionariesModule/interfaces/IDictionarySelectOption';

export const getKindControlSelectedLabel = (
  kindControlSelectOption: IDictionarySelectOption<ISupervisionType>,
  isUseTransferringAuthorities: boolean,
) => {
  if (
    kindControlSelectOption.transferred &&
    kindControlSelectOption.transferringAuthorities &&
    isUseTransferringAuthorities
  ) {
    const ervkTransferringTitles = kindControlSelectOption.transferringAuthorities
      .filter(x => x.title !== undefined && x.title !== null)
      .map(x => x.title);

    if (ervkTransferringTitles.length) {
      return `${kindControlSelectOption.number} - ${
        kindControlSelectOption.title
      } - передано от ${ervkTransferringTitles.join(', ')}`;
    }
  }

  return `${kindControlSelectOption.code} - ${kindControlSelectOption.label}`;
};
